export default __webpack_public_path__ + "static/media/cartificate.38c2b26d.svg";